import { render, staticRenderFns } from "./ServidorRO.vue?vue&type=template&id=7ab0f424"
import script from "./ServidorRO.vue?vue&type=script&lang=js"
export * from "./ServidorRO.vue?vue&type=script&lang=js"
import style0 from "./ServidorRO.vue?vue&type=style&index=0&id=7ab0f424&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports